import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { CampaignType } from '../typings/domain';
import {
    ContentPromotionDuplicateValidationResults,
    DuplicateGroupsModalViewState,
    DuplicateRadioControlType
} from '../typings/groups';

export const CLOSE_DUPLICATE_GROUPS_MODAL = 'CLOSE_DUPLICATE_GROUPS_MODAL';
export type CLOSE_DUPLICATE_GROUPS_MODAL = typeof CLOSE_DUPLICATE_GROUPS_MODAL;

export interface CloseDuplicateGroupsModal {
    type: CLOSE_DUPLICATE_GROUPS_MODAL;
}

export function closeDuplicateGroupsModal(): CloseDuplicateGroupsModal {
    return {
        type: CLOSE_DUPLICATE_GROUPS_MODAL
    };
}

export const CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE = 'CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE';
export type CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE = typeof CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE;

export interface ChangeDuplicateGroupsRadioButtonState {
    type: CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE;
    radioButtonNewState: DuplicateRadioControlType;
}

export function changeDuplicateGroupsRadioButtonState(
    radioButtonNewState: DuplicateRadioControlType
): ChangeDuplicateGroupsRadioButtonState {
    return {
        type: CHANGE_DUPLICATE_GROUPS_RADIO_CONTROL_STATE,
        radioButtonNewState
    };
}

export const CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE = 'CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE';
export type CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE = typeof CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE;

export interface ChangeDuplicateGroupsModalViewState {
    type: CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE;
    modalViewState: DuplicateGroupsModalViewState;
    campaignType?: CampaignType;
}

export function changeDuplicateGroupsModalViewState(
    modalViewState: DuplicateGroupsModalViewState,
    campaignType?: CampaignType
): ChangeDuplicateGroupsModalViewState {
    return {
        type: CHANGE_DUPLICATE_GROUPS_MODAL_VIEW_STATE,
        modalViewState,
        campaignType
    };
}

export const CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN = 'CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN';
export type CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN = typeof CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN;

export interface ClearDuplicateGroupsSelectedCampaign {
    type: CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN;
}

export function clearDuplicateGroupsSelectedCampaign(): ClearDuplicateGroupsSelectedCampaign {
    return {
        type: CLEAR_DUPLICATE_GROUPS_SELECTED_CAMPAIGN
    };
}

export const SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN = 'SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN';
export type SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN = typeof SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN;

export interface SetDuplicateGroupsSelectedCampaign {
    type: SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN;
}

export function setDuplicateGroupsSelectedCampaign(): SetDuplicateGroupsSelectedCampaign {
    return {
        type: SET_DUPLICATE_GROUPS_SELECTED_CAMPAIGN
    };
}

export const SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN = 'SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN';
export type SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN = typeof SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN;

export interface SetDuplicateGroupsDraftSelectedCampaign {
    type: SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN;
    draftCampaignSelected: SelectorItems;
}

export function setDuplicateGroupsDraftSelectedCampaign(
    draftCampaignSelected: SelectorItems
): SetDuplicateGroupsDraftSelectedCampaign {
    return {
        type: SET_DUPLICATE_GROUPS_DRAFT_SELECTED_CAMPAIGN,
        draftCampaignSelected
    };
}

export const RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE = 'RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE';
export type RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE = typeof RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE;

export interface ResetDuplicateGroupsCampaignSelectorState {
    type: RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE;
}

export function resetDuplicateGroupsCampaignSelectorState(): ResetDuplicateGroupsCampaignSelectorState {
    return {
        type: RESET_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_STATE
    };
}

export const FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS =
    'FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS';
export type FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS = typeof FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;

export interface FetchDuplicateGroupsCampaignSelectorDataItems {
    type: FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;
    textInput: string;
    campaignType?: CampaignType;
}

export function fetchDuplicateGroupsCampaignSelectorDataItems(
    textInput: string,
    campaignType?: CampaignType
): FetchDuplicateGroupsCampaignSelectorDataItems {
    return {
        type: FETCH_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS,
        textInput,
        campaignType
    };
}

export const UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS =
    'UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS';
export type UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS = typeof UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;

export interface UpdateDuplicateGroupsCampaignSelectorDataItems {
    type: UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;
    items: Array<SelectorItems>;
}

export function updateDuplicateGroupsCampaignSelectorDataItems(
    items: Array<SelectorItems>
): UpdateDuplicateGroupsCampaignSelectorDataItems {
    return {
        type: UPDATE_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS,
        items
    };
}

export const SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS =
    'SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS';
export type SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS = typeof SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;

export interface ShowErrorDuplicateGroupsCampaignSelectorDataItems {
    type: SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS;
}

export function showErrorDuplicateGroupsCampaignSelectorDataItems(): ShowErrorDuplicateGroupsCampaignSelectorDataItems {
    return {
        type: SHOW_ERROR_DUPLICATE_GROUPS_CAMPAIGN_SELECTOR_DATA_ITEMS
    };
}

export const ACCEPT_DUPLICATE_GROUPS_ITEMS = 'ACCEPT_DUPLICATE_GROUPS_ITEMS';
export type ACCEPT_DUPLICATE_GROUPS_ITEMS = typeof ACCEPT_DUPLICATE_GROUPS_ITEMS;

export interface AcceptDuplicateGroupsItems {
    type: ACCEPT_DUPLICATE_GROUPS_ITEMS;
}

export function acceptDuplicateGroupsItems(): AcceptDuplicateGroupsItems {
    return {
        type: ACCEPT_DUPLICATE_GROUPS_ITEMS
    };
}

export const SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS = 'SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS';
export type SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS = typeof SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS;

export interface SetAcceptToDuplicateSelectedGroups {
    type: SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS;
    copyErrorLimitIdxList: string[];
    copyErrorsBrokenGroupsIdxList: string[];
    contentPromotionErrors: ContentPromotionDuplicateValidationResults;
}

export function setAcceptToDuplicateSelectedGroups(
    copyErrorLimitIdxList: string[],
    copyErrorsBrokenGroupsIdxList: string[],
    contentPromotionErrors: ContentPromotionDuplicateValidationResults
): SetAcceptToDuplicateSelectedGroups {
    return {
        type: SET_ACCEPT_TO_DUPLICATE_SELECTED_GROUPS,
        copyErrorLimitIdxList,
        copyErrorsBrokenGroupsIdxList,
        contentPromotionErrors
    };
}

export type GroupsDuplicateSelectorActions =
    | ChangeDuplicateGroupsRadioButtonState
    | ChangeDuplicateGroupsModalViewState
    | ClearDuplicateGroupsSelectedCampaign
    | ResetDuplicateGroupsCampaignSelectorState
    | SetDuplicateGroupsSelectedCampaign
    | AcceptDuplicateGroupsItems
    | UpdateDuplicateGroupsCampaignSelectorDataItems
    | SetDuplicateGroupsDraftSelectedCampaign
    | SetAcceptToDuplicateSelectedGroups
    | FetchDuplicateGroupsCampaignSelectorDataItems
    | ShowErrorDuplicateGroupsCampaignSelectorDataItems
    | CloseDuplicateGroupsModal;
